import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { ChartLegend } from '../../../../../../../../components/chart-legend/chart-legend';
import { useBackdropContext } from '../../../../../../../../context/backdrop';
import { useChartFormat } from '../../hooks/use-chart-format';
import { CHART_COLORS, getComparatorUniqueSeries } from '../../utils/chart-comparator';
import { CustomTooltip } from './tooltip';

type ComparatorChartProps = {
  chartData: Record<string, number | string>[];
};

export const ComparatorChart: React.FC<ComparatorChartProps> = ({ chartData }) => {
  const { preventCarouselSwipe, unblockCarouselSwipe } = useBackdropContext();
  const { getLabel } = useChartFormat();

  const preventScroll = () => preventCarouselSwipe(true);

  const tariffs = getComparatorUniqueSeries(chartData);
  const legendData = tariffs.map((tariff, idx) => ({ label: getLabel(tariff), color: CHART_COLORS[idx] }));

  return (
    <div onTouchStart={preventScroll} onTouchEnd={unblockCarouselSwipe}>
      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={chartData} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="hour" />
          <YAxis />
          <Tooltip content={<CustomTooltip />} />
          {tariffs.map((tariff, index) => (
            <Line key={tariff} type="monotone" dataKey={tariff} stroke={CHART_COLORS[index]} dot={false} />
          ))}
        </LineChart>
      </ResponsiveContainer>
      <ChartLegend items={legendData} dotSize={12} fontSize={12} className="m-t-16" />
    </div>
  );
};
